module.exports = __webpack_public_path__ + "img/not-authorized.dedb6c2a.svg";